"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const react_icons_1 = require("react-icons");
const FaIcons = __importStar(require("react-icons/fa"));
const MdIcons = __importStar(require("react-icons/md"));
const IoIcons = __importStar(require("react-icons/io5"));
const md_1 = require("react-icons/md");
const rn_css_1 = require("rn-css");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const icon_list_1 = require("./icon_list");
const base_ui_theme_spacing_1 = require("@unboared/base-ui.theme.spacing");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const utils_1 = require("./utils");
const NotFoundIcon = md_1.MdError;
const CustomIcon = ({ LibIcon, name }) => {
    const MyIcon = LibIcon[name];
    if (!MyIcon)
        return react_1.default.createElement(NotFoundIcon, null);
    return react_1.default.createElement(MyIcon, null);
};
const GetIconType = (type) => ({ name }) => (react_1.default.createElement(CustomIcon, { name: name, LibIcon: type }));
const Icon = ({ name, color, size = base_ui_theme_spacing_1.space.medium }) => {
    // Transform size number into pixel string
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = (theme || base_ui_theme_themes_1.unboaredTheme.default);
    const icolor = color || currentTheme.textColor;
    const realSize = `${normalize(size)}px`;
    let { type, icon } = (0, utils_1.decomposeIconName)(icon_list_1.iconMap[name] || name);
    let Icon;
    switch (type) {
        case 'md':
            Icon = GetIconType(MdIcons);
            break;
        case 'fa':
            Icon = GetIconType(FaIcons);
            break;
        case 'io':
            Icon = GetIconType(IoIcons);
            break;
        default:
            Icon = GetIconType(MdIcons);
            break;
    }
    return (react_1.default.createElement(react_icons_1.IconContext.Provider, { value: { color: icolor, size: realSize, style: { verticalAlign: 'middle' } } },
        react_1.default.createElement(Icon, { name: icon })));
};
exports.Icon = Icon;
//# sourceMappingURL=icon.js.map